import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
  Stack,
  Chip,
  TextField,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Telecom from "../../images/telecom.jpg";
import AugrealImage from "../../images/augreal.jpg";
import TechnicalImage from "../../images/techical.jpg";
import ContingentImage from "../../images/Contingent.jpg";
import OfficeImage from "../../images/office.jpg";
import DataScienceImg from "../../images/DataScience.jpg";
import AwsImg from "../../images/the-aws-big-data.jpg";
import Ageimg from "../../images/age.jpg";
import TechcrisisImg from "../../images/Techcrisis.png";

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");

  const categories = [
    "All",
    "Infrastructure",
    "Application Development",
    "Recruiting",
    "Data Science",
    "Cloud Science",
  ];

  const blogPosts = [
    {
      id: 1,
      title: "All About Telecom OSS",
      category: "Infrastructure",
      author: "admin",
      date: "October 9, 2019",
      excerpt:
        "Operational Support Systems are also known as OSS is the information processing system used by operators or service providers to manage their communication networks to successfully perform their back office...",
      image: Telecom,
    },
    {
      id: 2,
      title: "Augmented Reality In Everyday Applications",
      category: "Application Development",
      author: "admin",
      date: "October 7, 2019",
      excerpt:
        "Augmented Reality, or AR as it is popularly known among the technical experts has been around for more than three decades ever since the first augmented reality took place in the...",
      image: AugrealImage
    },
    {
      id: 3,
      title: "Tips for creating a killer technical resume",
      category: "Recruiting",
      author: "admin",
      date: "September 25, 2019",
      excerpt:
        "Resume writing is an important skill in today's fast changing workplaces and technology. Especially a resume for presenting your skills on a resume as an experienced technology expert is quite challenging...",
      image: TechnicalImage,
    },
    {
      id: 4,
      title: "The benefits of using a contingent workforce",
      category: "Recruiting",
      author: "admin",
      date: "September 16, 2019",
      excerpt:
        "Contingent Work Force – Who are they? Contingent workforce is also known with the names such as independent contractors, freelancers, consultants or other outsourced and non-permanent/temporary workers who are hired...",
      image: ContingentImage,
    },
    {
      id: 5,
      title: "The benefits of staffing and its types",
      category: "Recruiting",
      author: "admin",
      date: "September 16, 2019",
      excerpt:
        "Staffing – An Introduction and Its Importance Staffing in normal parlance is the process of hiring and developing the required personnel to fill in various positions in an organization and...",
      image: OfficeImage,
    },
    {
      id: 6,
      title: "What is data analytics and how is it used?",
      category: "Data Science",
      author: "admin",
      date: "August 16, 2019",
      excerpt:
        "Data Analytics – What it is and its importance Data Analytics in normal parlance can be defined as the process of examining data sets that are extracted and categorized to...",
      image: DataScienceImg,
    },
    {
      id: 7,
      title: "Big Data on Amazon Web Services",
      category: "Data Science",
      author: "admin",
      date: "June 16, 2019",
      excerpt:
        "Big Data – Its Importance and Utility The concept of Big Data has been around for years with a majority of organizations understanding the true value of big data thereby...",
      image: AwsImg,
    },
    {
      id: 8,
      title: "Are you at risk for age discrimination?",
      category: "Recruiting",
      author: "admin",
      date: "May 19, 2019",
      excerpt:
        "I am seeing a growing number of tech and other services companies in Indianapolis with zero, or very few (less than 10%), employees who are 45 or older- even in...",
      image: Ageimg,
    },
    {
      id: 9,
      title: "The Tech Industry Tenure Crisis",
      category: "Recruiting",
      author: "admin",
      date: "April 16, 2019",
      excerpt:
        "With data compiled from a variety of sources, this graphic points to a big problem with tenure in tech. Is it the nature of the tech business? Is it...",
      image: TechcrisisImg,
    },
  ];

  // Filter posts based on selected category and search term
  const filteredPosts = blogPosts.filter((post) => {
    const categoryMatch =
      selectedCategory === "All" || post.category === selectedCategory;
    const searchMatch =
      post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return categoryMatch && searchMatch;
  });

  // Hero Section
  const HeroSection = () => (
    <Box
      sx={{
        background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
        color: "white",
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 900,
            fontSize: { xs: "2rem", md: "2.4rem" },
          }}
        >
          Blog
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 1,
            opacity: 0.95,
            fontSize: { xs: "0.95rem", md: "1.1rem" },
          }}
        >
          Insights, articles, and news about staffing and project solutions
        </Typography>
      </Container>
    </Box>
  );

  // Main Blog Section
  const BlogSection = () => (
    <Box sx={{ py: { xs: 4, md: 6 }, bgcolor: "background.paper" }}>
      <Container maxWidth="lg">
        {/* Search Bar */}
        {/* <Box sx={{ mb: 6 }}>
          <TextField
            fullWidth
            placeholder="Search articles..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <SearchIcon sx={{ mr: 1, color: "text.secondary" }} />
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                bgcolor: "#f5f7fa",
                borderRadius: 2,
              },
            }}
          />
        </Box> */}

        {/* Category Filter */}
        <Box sx={{ mb: 6, display: "flex", flexWrap: "wrap", gap: 1 }}>
          {categories.map((category) => (
            <Chip
              key={category}
              label={category}
              onClick={() => setSelectedCategory(category)}
              variant={selectedCategory === category ? "filled" : "outlined"}
              sx={{
                fontWeight: 700,
                fontSize: "15px",
                backgroundColor:
                  selectedCategory === category ? "#2a5298" : "transparent",
                color: selectedCategory === category ? "white" : "#2a5298",
                borderColor: "#2a5298",
                cursor: "pointer",
                padding: "8px 16px",
                height: "auto",
              }}
            />
          ))}
        </Box>

        {/* Blog Posts Grid */}
        <Grid container spacing={4}>
          {filteredPosts.length > 0 ? (
            filteredPosts.map((post) => (
              <Grid item xs={12} md={6} lg={4} key={post.id}>
                <Card
                  sx={{
                    height: "100%",
                    borderRadius: 2,
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    transition: "all 0.3s ease",
                    display: "flex",
                    flexDirection: "column",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 12px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  {/* Image */}
                  <CardMedia
                    component="img"
                    height="240"
                    image={post.image}
                    alt={post.title}
                    sx={{ objectFit: "cover" }}
                  />

                  {/* Content */}
                  <CardContent
                    sx={{
                      p: { xs: 2, md: 2.5 },
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* Category */}
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: "14px",
                        color: "#2a5298",
                        fontWeight: 700,
                        // textTransform: "uppercase",
                        letterSpacing: 0.5,
                        mb: 1,
                      }}
                    >
                      {post.category}
                    </Typography>

                    {/* Title */}
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        mb: 1.5,
                        color: "#000",
                        fontSize: { xs: "1.1rem", md: "22px" },
                        lineHeight: 1.4,
                        flex: 1,
                      }}
                    >
                      {post.title}
                    </Typography>

                    {/* Excerpt */}
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        mb: 2,
                        lineHeight: 1.6,
                        fontWeight: 500,
                        fontSize: { xs: "0.85rem", md: "0.95rem" },
                      }}
                    >
                      {post.excerpt}
                    </Typography>

                    {/* Meta Info */}
                    {/* <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pt: 2,
                        borderTop: "1px solid #E0E0E0",
                      }}
                    >
                      <Stack direction="row" spacing={0.5} alignItems="center">
                        <CalendarTodayIcon
                          sx={{
                            fontSize: 14,
                            color: "text.secondary",
                          }}
                        />
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ fontSize: { xs: "0.75rem", md: "0.8rem" } }}
                        >
                          {post.date}
                        </Typography>
                      </Stack>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#2a5298",
                          fontWeight: 600,
                          fontSize: { xs: "0.75rem", md: "0.8rem" },
                        }}
                      >
                        By {post.author}
                      </Typography>
                    </Box> */}
                  </CardContent>

                  {/* Read More Button */}
                  <Box sx={{ p: { xs: 2, md: 3 }, pt: 0 }}>
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      sx={{
                        color: "#2a5298",
                        borderColor: "#2a5298",
                        fontWeight: 700,
                        fontSize: "15px",
                        "&:hover": {
                          bgcolor: "rgba(42, 82, 152, 0.04)",
                        },
                      }}
                    >
                      Read More
                    </Button>
                  </Box>
                </Card>
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Box sx={{ textAlign: "center", py: 6 }}>
                <Typography color="text.secondary">
                  No articles found. Try a different search term or category.
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );

  return (
    <Box>
      <HeroSection />
      <BlogSection />
    </Box>
  );
};

export default Blog;
